import $http from '@/api/index'
/**
 * @description 获取历史消息记录 参数:fromId, toId, infoType, num
 * @constructor
 */
function GetHistoryMessage(fromId, toId, infoType, num, toServer) {
	let getUrl = {
		method: 'GET',
		url: 'message/HistoryMessage',
		requestType: 5,
	}
	let params = {
		fromId: (infoType == 11 || infoType == 12)? '' : fromId,
		toId: toId,
		infoType: infoType,
		num: num,
		toServer: toServer ? toServer.toString() : ""
	}
	return $http(getUrl, params)
}
/**
 * @description 删除离线消息 参数:id, userId
 * @constructor
 */
function RemoveOfflineMessage(id, userId) {
	let getUrl = {
		method: 'POST',
		url: 'message/RemoveOfflineMessage?id=' + id + '&userId=' + userId,
		requestType: 5
	}
	let params = {}
	return $http(getUrl, params)
}
/**
 * @description 获取文件-单人 source, target, fileType
 * @constructor
 */
function GetFileToUser(source, target, fileType){
	let getUrl = {
		method: 'GET',
		url: 'file/User',
		requestType: 5
	}
	let params = {
		source: source,
		target: target,
		fileType: fileType
	}
	return $http(getUrl, params)
}
/**
 * @description 获取文件-群组 groupId, fileType
 * @constructor
 */
function GetFileToGroup(groupId, fileType){
	let getUrl = {
		method: 'GET',
		url: 'file/Group',
		requestType: 5
	}
	let params = {
		groupId: groupId,
		fileType: fileType
	}
	return $http(getUrl, params)
}
/**
 * @description 获取群人员 GetGroupMember
 * @constructor
 */
function GetGroupMember(groupId){
	let getUrl = {
		method: 'GET',
		url: 'group/Member',
		requestType: 5
	}
	let params = {
		groupId: groupId
	}
	return $http(getUrl, params)
}
/**
 * @description 下载文件 参数id
 * @constructor
 */
function fileDownload(id){
	let getUrl = {
		method: 'GET',
		url: 'file/Download',
		requestType: 5
	}
	let params = {
		id: id
	}
	return $http(getUrl, params)
}
/**
 * @description 上传文件 fileName createUser createUserName createDept createDeptName businessId fileType file
 * @constructor
 */
function fileUpload(fromData){
	let getUrl = {
		method: 'POST',
		url: 'file/Upload',
		requestType: 5,
		isFormData: true
	}
	return $http(getUrl, fromData)
}


//文件类型检索接口
// function fileQuery(beginTime,endTime,uploadUser,fileName){
function fileQuery(params){
	let getUrl = {
		method: 'POST',
		url: 'file/Query',
		requestType: 5
	}
// 	let params = {
// 		"BeginTime": beginTime,
// 		"EndTime": endTime,
// 		"UploadUser": uploadUser,
// 		"FileName": fileName
// 	}
	return $http(getUrl, params)
}
export default {
	GetHistoryMessage,
	RemoveOfflineMessage,
	GetFileToUser, 
	GetFileToGroup,
	GetGroupMember,
	fileDownload,
	fileUpload,
	fileQuery
}
